import { Selector } from './Selector';
import {
  FORECAST_MODELS,
  ForecastModel,
  BaseForecastModelWithAvailability,
  BaseLiveBenchmarkingModelWithAvailability,
} from '../../common/static-data/models';

interface ModelSelectorProps {
  selectedModels: ForecastModel[];
  onChange: (models: ForecastModel[]) => void;
  disabled?: boolean;
  models?:
    readonly BaseForecastModelWithAvailability[] | BaseLiveBenchmarkingModelWithAvailability[];
  multiple?: boolean;
  className?: string;
  hideLabel?: boolean;
  dropdownDirection?: 'up' | 'down' | 'auto';
}

export function ModelSelector({
  selectedModels,
  onChange,
  disabled = false,
  models = FORECAST_MODELS,
  multiple = true,
  hideLabel = false,
  className,
  dropdownDirection = 'auto',
}: ModelSelectorProps) {
  return (
    <div className={className}>
      <Selector
        label="Model"
        hideLabel={hideLabel}
        options={models.map((model) => ({
          ...model,
          metadata: {
            Resolution: model.resolution,
            Updates: model.updateFrequency,
          },
          disabled: !model.available,
        }))}
        value={selectedModels}
        onChange={(value) => onChange(Array.isArray(value) ? value : [value])}
        disabled={disabled}
        multiple={multiple}
        data-ph-capture-attribute="dropdown-model-selector"
        dropdownDirection={dropdownDirection}
      />
    </div>
  );
}
